import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../../App';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { SidebarModal } from '../../../components/common/Sidebar/Sidebar';
import { USDT_USDC, formatUSD } from '../../../helpers/helperFunctions';
import { CaptionText, H3, H4, P1, P2, P3 } from '../../../styles/FontStyles';
import {
  EarningBox,
  Flexed,
  PageTitle
} from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import {
  Icon,
  IconEarningsPartner,
  IconEarningsTotal,
  IconTodayEarnings,
  IconWarning,
  IconWithdrawAlert
} from '../../../styles/Icons';
import {
  Flex,
  FlexBetween,
  FlexCenter,
  FloatingButtonBackoffice
} from '../../../styles/stylesStyled';
import { NoKyc } from '../../Dashboard/NoKyc';
import { Withdraw } from '../Withdraw/Withdraw';
import { EarningsPageEnum, EarningsHistoryFilterEnum } from '../Earnings.types';
import { TopUp } from '../TopUp/TopUp';
import { TextWithTooltip } from '../../../components/common/TextWithTooltip';
import Countdown from 'react-countdown';
import { FlipMeBanner } from '../../FlipMeWallet/FlipMeBanner';
import { Button } from '../../../components';
import axios from 'axios';
import { WithdrawTwoFARequired } from '../Withdraw/WithdrawTwoFARequired';
import { settingsInit } from '../../Settings/Settings.actions';

import Modal from 'react-modal';
import { CircleIconWrapper } from './EarningsStyled';

export enum WithdrawSteps {
  FINAL = 1,
  TWO_FA,
  SUCCESS,
  KYC
}

export enum KysStatuses {
  NOT_STARTED = -1,
  INIT = 0,
  PENDING = 1,
  PRECHECKED = 2,
  QUEUED = 3,
  COMPLETED = 4,
  ON_HOLD = 5,
  AWAITING_SERVICE = 6,
  AWAITING_USER = 7
}
interface EarningsProps {
  setMobilePage: Dispatch<SetStateAction<EarningsPageEnum>>;
  withdraw: boolean;
  topUp: boolean;
  transfer: boolean;
  setTransfer: Dispatch<SetStateAction<boolean>>;
  setTopUp: Dispatch<SetStateAction<boolean>>;
  setWithdraw: Dispatch<SetStateAction<boolean>>;
  HandleChangeFilter: (filter: EarningsHistoryFilterEnum) => void;
}

export const EarningsInfo = ({
  setMobilePage,
  withdraw,
  topUp,
  setTopUp,
  setWithdraw,
  transfer,
  setTransfer,
  HandleChangeFilter
}: EarningsProps) => {
  const { t } = useTranslation('earnings');

  const [step, setStep] = useState(1);
  const [noKyc, setNoKyc] = useState(false);

  const [amount, setAmount] = useState('');
  const [accessSDKToken, setAccessSDKToken] = useState<string>('');
  const [twoFaFactor, setTwoFaFactor] = useState(false);
  const [verification, setVerification] = useState(false);
  const [kycStatus, setKycStatus] = useState();

  const { info } = useAppSelector((state) => state.earnings);
  const { verificationStatus } = useAppSelector((state) => state.settings);
  const dispatch = useAppDispatch();

  const handleWithdrawButton = async () => {
    const kycStatus = await getKYCStatuses();

    if (kycStatus === KysStatuses.COMPLETED) {
      setStep(1);

      if (!verificationStatus) {
        setTwoFaFactor(true);
      } else {
        setAmount('');
        setWithdraw(true);
      }
    } else {
      setVerification(true);
    }
  };

  const getAccessToken = async () => {
    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const { data } = await axios.get(`${apiURL}/kyc/sumsub-direct/sdk-token`);

      setAccessSDKToken(data.data.token);
    } catch (error) {
      console.log(error);
    }
  };

  const getKYCStatuses = async () => {
    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const { data } = await axios.get(`${apiURL}/kyc/status`);

      return data.data.status;
      // setKycStatus(data.data.status);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAccessToken();
    // getKYCStatuses();
    dispatch(settingsInit());
  }, [dispatch]);

  return (
    <div>
      <FlexBetween style={{ marginBottom: 20 }}>
        <PageTitle color={color.colors.neutral0}>{t('title')}</PageTitle>

        <Desktop>
          <Flex
            style={{
              flexWrap: 'wrap',
              justifyContent: 'flex-end'
            }}>
            {/* <Button w='130px' m='6px' onClick={handleTopUpButton} negativeLight>
              {t('top_up')}
            </Button> */}
            <Button
              negativeLight
              w='130px'
              m='6px'
              onClick={handleWithdrawButton}>
              {t('withdraw')}
            </Button>
          </Flex>
        </Desktop>
        <Mobile>
          <FloatingButtonBackoffice>
            <Flexed>
              {/* <Button m='6px' onClick={handleTopUpButton}>
                {t('top_up')}
              </Button> */}
            </Flexed>
            <Flexed>
              <Button m='6px' onClick={handleWithdrawButton}>
                {t('withdraw')}
              </Button>
            </Flexed>
          </FloatingButtonBackoffice>
        </Mobile>
        <Mobile>
          <Button
            negativeLight
            p='0 15px'
            onClick={() => setMobilePage(EarningsPageEnum.EARNINGS_HISTORY)}>
            {t('show_history')}
          </Button>
        </Mobile>
      </FlexBetween>
      <FlexCenter style={{ marginBottom: 12, marginTop: 20 }}>
        <Icon color={color.colors.neutral0} mr='8'>
          <IconEarningsTotal />
        </Icon>
        <P3 color={color.colors.neutral0} bold>
          {t('total_earnings')}
        </P3>
      </FlexCenter>

      <EarningBox>
        <CaptionText mb='8' caps color={color.colors.neutral700}>
          {t('total_earnings')}
        </CaptionText>
        <Flexed center end='true'>
          <P2 bold mb='8' color={color.colors.neutral900}>
            {formatUSD(info?.totalEarnings?.totalEarnings)}
          </P2>
        </Flexed>
        <Flexed center end='true'>
          <FlexCenter>
            <Icon color={color.colors.primary900}>
              <IconTodayEarnings />
            </Icon>
            <CaptionText ml='4' caps color={color.colors.primary900} bold>
              {info?.totalEarnings?.todayTotalEarnings}
            </CaptionText>

            <CaptionText ml='4' caps color={color.colors.primary900} bold>
              {t('today')}
            </CaptionText>
          </FlexCenter>
        </Flexed>
      </EarningBox>

      <EarningBox>
        <CaptionText mb='8' caps color={color.colors.neutral700}>
          USDT / USDC ACCOUNT
        </CaptionText>
        <Flexed center end='true'>
          <P2 bold mb='8' color={color.colors.neutral900}>
            {formatUSD(info?.totalEarnings?.availableBalance)}
          </P2>
        </Flexed>
        <Flexed center end='true'>
          <FlexCenter>
            <Icon color={color.colors.primary900}>
              <IconTodayEarnings />
            </Icon>
            <CaptionText ml='4' caps color={color.colors.primary900} bold>
              {info?.totalEarnings?.todayAvailableBalance}
            </CaptionText>

            <CaptionText ml='4' caps color={color.colors.primary900} bold>
              {t('today')}
            </CaptionText>
          </FlexCenter>
        </Flexed>
      </EarningBox>

      <EarningBox>
        <CaptionText caps color={color.colors.neutral700}>
          United One Account
        </CaptionText>

        <Flexed center end='true'>
          <P2 bold mb='8' color={color.colors.neutral900}>
            {formatUSD(info?.totalEarnings?.shoppingPoints)}
          </P2>
        </Flexed>
        <Flexed center end='true'>
          <FlexCenter>
            <Icon color={color.colors.primary900}>
              <IconTodayEarnings />
            </Icon>
            <CaptionText ml='4' caps color={color.colors.primary900} bold>
              {info?.totalEarnings?.todayShoppingPoints}
            </CaptionText>

            <CaptionText ml='4' caps color={color.colors.primary900} bold>
              {t('today')}
            </CaptionText>
          </FlexCenter>
        </Flexed>
      </EarningBox>

      <FlexCenter style={{ marginBottom: 12 }}>
        <Icon color={color.colors.neutral0} mr='8'>
          <IconEarningsPartner />
        </Icon>
        <P3 color={color.colors.neutral0} bold>
          {t('partner_earnings')}
        </P3>
      </FlexCenter>

      <EarningBox>
        <CaptionText mb='8' caps color={color.colors.neutral700}>
          {t('direct_bonus')}
        </CaptionText>

        <FlexBetween style={{ alignItems: 'end' }}>
          <Button
            fs='11px'
            h='30px'
            maxWidth='70px'
            negative
            style={{ fontWeight: 500 }}
            onClick={() => {
              setMobilePage(EarningsPageEnum.EARNINGS_HISTORY);
              HandleChangeFilter(EarningsHistoryFilterEnum.DIRECT_BONUS);
            }}>
            INFO
          </Button>
          <div>
            <Flexed center end='true'>
              <P2 bold mb='8' color={color.colors.neutral900}>
                {formatUSD(info?.partnerEarnings?.directBonusEarnings)}{' '}
                {USDT_USDC}
              </P2>
            </Flexed>
            <Flexed center end='true'>
              <FlexCenter>
                <Icon color={color.colors.primary900}>
                  <IconTodayEarnings />
                </Icon>
                <CaptionText ml='4' caps color={color.colors.primary900} bold>
                  {info?.partnerEarnings?.todayDirectBonusEarnings}
                </CaptionText>

                <CaptionText ml='4' caps color={color.colors.primary900} bold>
                  {t('today')}
                </CaptionText>
              </FlexCenter>
            </Flexed>
          </div>
        </FlexBetween>
      </EarningBox>

      <EarningBox>
        <CaptionText mb='8' caps color={color.colors.neutral700}>
          {t('team_bonus')}
        </CaptionText>

        <FlexBetween style={{ alignItems: 'end' }}>
          <Button
            fs='11px'
            h='30px'
            maxWidth='70px'
            negative
            style={{ fontWeight: 500 }}
            onClick={() => {
              setMobilePage(EarningsPageEnum.EARNINGS_HISTORY);
              HandleChangeFilter(EarningsHistoryFilterEnum.TEAM_BONUS);
            }}>
            INFO
          </Button>
          <div>
            <Flexed center end='true'>
              <P2 bold mb='8' color={color.colors.neutral900}>
                {formatUSD(info?.partnerEarnings?.teamBonusEarnings)}{' '}
                {USDT_USDC}
              </P2>
            </Flexed>
            <Flexed center end='true'>
              <FlexCenter>
                <Icon color={color.colors.primary900}>
                  <IconTodayEarnings />
                </Icon>
                <CaptionText ml='4' caps color={color.colors.primary900} bold>
                  {info?.partnerEarnings?.todayTeamBonusEarnings}
                </CaptionText>

                <CaptionText ml='4' caps color={color.colors.primary900} bold>
                  {t('today')}
                </CaptionText>
              </FlexCenter>
            </Flexed>
          </div>
        </FlexBetween>
      </EarningBox>

      <EarningBox disabled>
        <CaptionText mb='8' caps color={color.colors.neutral700}>
          {t('matching_bonus')}
        </CaptionText>

        <FlexBetween style={{ alignItems: 'end' }}>
          <Button
            fs='11px'
            h='30px'
            maxWidth='70px'
            negative
            style={{ fontWeight: 500 }}
            disabled>
            INFO
          </Button>
          <div>
            <Flexed center end='true'>
              <P2 bold mb='8' color={color.colors.neutral900}>
                {formatUSD(info?.partnerEarnings?.matchingBonusEarnings)}{' '}
                {USDT_USDC}
              </P2>
            </Flexed>
            <Flexed center end='true'>
              <FlexCenter>
                <Icon color={color.colors.primary900}>
                  <IconTodayEarnings />
                </Icon>
                <CaptionText ml='4' caps color={color.colors.primary900} bold>
                  {info?.partnerEarnings?.todayMatchingBonusEarnings}
                </CaptionText>

                <CaptionText ml='4' caps color={color.colors.primary900} bold>
                  {t('today')}
                </CaptionText>
              </FlexCenter>
            </Flexed>
          </div>
        </FlexBetween>
      </EarningBox>

      <EarningBox disabled>
        <CaptionText mb='8' caps color={color.colors.neutral700}>
          Fast Start Bonus
        </CaptionText>

        <FlexBetween style={{ alignItems: 'end' }}>
          <Button
            fs='11px'
            h='30px'
            maxWidth='70px'
            negative
            style={{ fontWeight: 500 }}
            disabled>
            INFO
          </Button>
          <div>
            <Flexed center end='true'>
              <P2 bold mb='8' color={color.colors.neutral900}>
                {formatUSD(info?.partnerEarnings?.cashbackBonusEarnings)}{' '}
                {USDT_USDC}
              </P2>
            </Flexed>
            <Flexed center end='true'>
              <FlexCenter>
                <Icon color={color.colors.primary900}>
                  <IconTodayEarnings />
                </Icon>
                <CaptionText ml='4' caps color={color.colors.primary900} bold>
                  {info?.partnerEarnings?.todayCashbackBonusEarnings}
                </CaptionText>

                <CaptionText ml='4' caps color={color.colors.primary900} bold>
                  {t('today')}
                </CaptionText>
              </FlexCenter>
            </Flexed>
          </div>
        </FlexBetween>
      </EarningBox>

      <SidebarModal
        isOpen={withdraw}
        setOpen={setWithdraw}
        title={`USDT/USDC Withdrawal`}
        sidebarWidth={'508px'}>
        <Withdraw
          step={step}
          setStep={setStep}
          setWithdraw={setWithdraw}
          amount={amount}
          setAmount={setAmount}
        />
      </SidebarModal>

      <SidebarModal
        isOpen={twoFaFactor}
        setOpen={setTwoFaFactor}
        title={t('verify_your_account')}
        sidebarWidth={'508px'}>
        <WithdrawTwoFARequired />
      </SidebarModal>

      {/* <SidebarModal
        isOpen={topUp}
        setOpen={setTopUp}
        title={t('top_up')}
        sidebarWidth={'508px'}>
        <TopUp setTopUp={setTopUp} />
      </SidebarModal> */}

      <SidebarModal
        isOpen={noKyc}
        setOpen={setNoKyc}
        title={t('verify_your_account')}
        sidebarWidth={'508px'}>
        <NoKyc accessSDKToken={accessSDKToken} />
      </SidebarModal>

      <Modal
        isOpen={verification}
        overlayClassName='myoverlay'
        closeTimeoutMS={500}
        ariaHideApp={false}
        className={'cameraModal'}>
        <Flexed p='20px'>
          <Flexed column>
            <Flexed>
              <Icon>
                <CircleIconWrapper
                  color={color.colors.secondary100}
                  mb='10px'
                  heigth={24}>
                  <Icon pointer color={color.colors.neutral50}>
                    <IconWithdrawAlert height='14' />
                  </Icon>
                </CircleIconWrapper>
              </Icon>
              <P1 mb='10' ml='10' bold>
                Verify your identity
              </P1>
            </Flexed>

            <P3 ml='34'>
              To keep your account secure and comply with regulations, we need
              to verify your identity. This process is quick and secure. Please
              have a valid government-issued ID ready.
            </P3>
            <Flexed end mt='20'>
              <Button
                negative
                maxWidth='200px'
                mr='20'
                onClick={() => {
                  setVerification(false);
                }}>
                Cancel
              </Button>
              <Button
                maxWidth='200px'
                onClick={() => {
                  setVerification(false);
                  setNoKyc(true);
                }}>
                Continue to Verification
              </Button>
            </Flexed>
          </Flexed>

          {/* <H3 caps mb='30' center>
            Super Node Update:
          </H3>
          <P2 mb='40' color={colors.neutral700}>
            Starting August, 14th 2025, we'll remove all $AK1111 tokens from
            your Super Nodes and replace them with $ULX on a dollar-for-dollar
            basis (USD value at transition). <br /> This strategic move protects
            our community, eliminates external risks, and strengthens Mavie's
            independence. No action needed—it's automatic. Your rewards and
            functionality remain unchanged.
          </P2>
          <Button
            onClick={() => {
              setModal(!modal);
              dispatch(checkAkashaModal(history));
            }}>
            Close
          </Button> */}
        </Flexed>
      </Modal>
    </div>
  );
};
